export default __webpack_public_path__ + "static/media/28-2_delete.15397c36.svg";